import { ArrowUp, Mail, Phone } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="footer" className="relative overflow-hidden bg-ink pt-20 pb-10">
            <div className="mx-auto max-w-6xl px-5 sm:px-8">
                <div className="flex flex-col items-start justify-between gap-8 border-b border-white/10 pb-12 sm:flex-row sm:items-center">
                    <div className="flex items-center">
                        <img
                            src="/focs-logo-full.png"
                            alt="FocS Global — Influencer Marketing Agency"
                            className="h-20 w-auto sm:h-24"
                        />
                    </div>

                    <div className="flex flex-col gap-3 sm:items-end">
                        <a
                            href="mailto:Connect@focs.site"
                            data-testid="footer-email-link"
                            className="flex items-center gap-2.5 text-sm text-slate-400 transition-colors hover:text-white"
                        >
                            <Mail className="h-4 w-4 text-crimson" />
                            Connect@focs.site
                        </a>
                        <a
                            href="tel:+919180399805"
                            data-testid="footer-phone-link"
                            className="flex items-center gap-2.5 text-sm text-slate-400 transition-colors hover:text-white"
                        >
                            <Phone className="h-4 w-4 text-crimson" />
                            +91 9180399805
                        </a>
                    </div>
                </div>

                <div className="flex flex-col items-start justify-between gap-6 pt-8 sm:flex-row sm:items-center">
                    <p className="text-xs text-slate-600">
                        © 2026 FocS. All rights reserved.
                    </p>
                    <a
                        href="#top"
                        data-testid="back-to-top"
                        className="group inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-xs font-semibold text-slate-300 transition-colors hover:border-white/40 hover:text-white"
                    >
                        Back to top
                        <ArrowUp className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5" />
                    </a>
                </div>
            </div>

            <img
                src="/focs-logo-full.png"
                alt=""
                aria-hidden="true"
                className="pointer-events-none mx-auto mt-4 w-[min(72vw,520px)] select-none opacity-[0.07]"
            />
        </footer>
    );
}
